module.exports = __webpack_public_path__ + "media/images/badge/conquiztador-6408af49ebc5b07814262eb1c86c063d.png";